<!-- <hr style="margin-top: 0px; margin-bottom: 0px;"> -->

<div *ngIf="isReadyAllSensors && isReadySensorGroups; else loading" class="col-md-12">

    <p-confirmDialog key="cd" #cd>
        <ng-template #footer>
            <button (click)="cd.onAccept()" class="btn btn-success" type="button">Yes</button>
            <button (click)="cd.onReject()" class="btn btn-basic" type="button">No</button>
        </ng-template>
    </p-confirmDialog>

    <div class="form-group">
        <ng-template #scanner class="qrScanner" let-modal>
            <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content">
                <div style="background-color: #548235;  height: 7px;"></div>
                <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
                    <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">QR Code Scanner</h5>
                    <button
                        (click)="scanModalRef.hide()"
                        class="ms-auto fas fa-times" type="button"
                        style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
                    </button>
                </div>
                <div class="modal-body qr-scanner-body" style="padding: 0px;">
                    <kig-scanner (scanSuccess)="scanComplete($event)" (camerasFound)="camerasFound($event)" [device]="selectedDevice" id="scanZX"></kig-scanner><br>

                    <select (change)="onDeviceSelectChange($event.target.value)" style="height: 38px; width: 455px; margin-left: 20px;">
                        <option value="" [selected]="!selectedDevice">No Device</option>
                        <option *ngFor="let device of availableDevices"
                            [value]="device.deviceId"
                            [selected]="selectedDevice && device.deviceId === selectedDevice.deviceId">{{ device.label }}
                        </option>
                    </select>

                    <div style="display: flex; gap: 10px;">
                        <input type="text" [(ngModel)]="scannedSensor" name="sensorUUID" style="width: 280px; height: 35px; margin-left: 20px; margin-top: 20px;" autofocus />
                        <button (click)="addSensor()" [disabled]="scannedSensor === ''" class="btn btn-success" id="acceptButton" type="button" style="height: 35px; margin-top: 20px; margin-right: 0px;">Add</button>
                        <button (click)="ignoreSensor()" [disabled]="scannedSensor === ''" class="btn btn-danger" id="ignoreButton" type="button" style="height: 35px; margin-top: 20px;">Ignore</button>
                    </div>
                </div>
            </div>
        </ng-template>

        <p-table #sensorTable [columns]="sensorCols" [value]="sensorsDisplayed" sortMode="multiple" [exportFunction]="exportCSV" exportFilename={{exportFilename}}>
            <ng-template pTemplate="caption">
                <div style="text-align: left; display: flex; gap: 10px; align-items: center; margin-bottom: 0px; flex-wrap: wrap;">
                    
                    <div style="display: block; width: 170px;">
                        <label style="font-size: large; vertical-align: middle; color:black; font-weight: 500;">SENSORS</label>
                        <div style="display: flex; gap: 8px;" class="text-center">
                            <div style="display: block;">
                                <div style="font-size: 12px;">Displayed</div>
                                <div style="font-size: 12px;">{{ sensorsDisplayed.length }}</div>
                            </div>
                            <div style="display: block;">
                                <div style="font-size: 12px;">Selected</div>
                                <div (click)="showSelectedSensors()" style="font-size: 12px; cursor: pointer;">{{ sensorsSelected.length }}</div>
                            </div>
                            <div style="display: block;">
                                <div style="font-size: 12px;">Total</div>
                                <div style="font-size: 12px;">{{ allSensors.length }}</div>
                            </div>
                        </div>
                    </div>

                    <div style="text-align: left; display: flex; gap: 10px; align-items: center; min-width: 630px;">
                        <form (ngSubmit)="searchSensorsTextChanged()">
                            <i class="fa fa-search" style="margin:4px 4px 0 0; cursor: pointer;" (click)="searchSensorsTextChanged()"></i>
                            <i class="fa-solid fa-magnifying-glass-minus" style="margin:4px 4px 0 0; cursor: pointer;" (click)="clearSearchFilter()"></i>
                            <input *ngIf="sensorsDisplayed.length > 0" [(ngModel)]="sensorSearch" placeholder="Name/UUID/Type/Condition" size="25" style="width:auto; height: 35px; border: 1px dashed red;" type="text" name="sensorSearch" autocomplete="off"/>
                            <input *ngIf="sensorsDisplayed.length < 1" [(ngModel)]="sensorSearch" placeholder="Name/UUID/Type/Condition" size="25" style="width:auto; height: 35px; border: 1px solid lightgray;" type="text" name="sensorSearch" autocomplete="off"/>
                        </form>
                        <label>or</label>
                        <span style="width: 210px">
                            <ng-select [items]=sensorGroups bindLabel="name"
                                (change)="selectSensorsInSensorGroup($event)" placeholder="Search by Sensor Groups"
                                [(ngModel)]="sensorGroup" style="width: 210px" >
                            </ng-select>
                        </span>
                        <label>or</label>
                        <button (click)="openScanModal(scanner)" class=" btn btn-warning pull-right" style="float: right; padding-top: 4px; height: 35px;" type="button">Scan QR</button>
                        <label style="font-size: 20px; margin-top: -4px;">|</label>
                    </div>

                    <button (click)="newSensor(sensorEditTemplate)" style="height: 35px; padding-top: 4px; min-width: 124px;" class="btn btn-success" type="button">Create Sensor</button>
                    <button (click)="showSensorImportModal()" style="height: 35px; padding-top: 4px; min-width: 74px;" class="btn btn-primary" type="button">Import</button>
                    <button (click)="sensorTable.exportCSV()" class="btn btn-primary" style="height: 35px; padding-top: 4px; min-width: 72px;" [disabled]="sensorsDisplayed.length < 1" >Export</button>
                    <button (click)="startReplaceSensor(sensorReplaceTemplate)" style="height: 35px; padding-top: 4px; min-width: 81px;" class="btn btn-primary" type="button">Replace</button>
                    <button (click)="setOwnerForSensors(groupOwnerTemplate)" style="height: 35px; padding-top: 4px; min-width: 100px;" [disabled]="sensorsSelected.length < 1" class="btn btn-primary" type="button">Set Owner</button>
                    <button (click)="createOrUpdateSensorgroup()" type="button" class="btn btn-info" style="height: 38px; min-width: 173px;" [disabled]="sensorsSelected.length < 1" >Create Sensor Group</button>
                    <div style="border: 1px dotted lightgray; padding: 3px;">
                        <button (click)="updateSensors()" class="btn btn-success btn-sm" *ngIf="sensorEdited" style="margin-right: 8px;">Save Edits</button>
                        <button (click)="revertSensorChanges()" class="btn btn-success btn-sm" *ngIf="sensorEdited" >Revert Edits</button>
                    </div>
                </div>  
            </ng-template>

            <ng-template let-columns pTemplate="header">
                <tr style="height: 45px;">
                    <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field" style="background-color: var(--kig-section-header-bg); flex: none;">
                        <div *ngIf="col.field == 'checkbox'" (click)="toggleCheckedSensorsDisplayed()" style="padding-left: 2px; font-size: 20px;">▣</div>
                        {{col.header}}
                    </th>
                </tr>
            </ng-template>

            <ng-template let-columns="columns" let-i="rowIndex" let-rowData pTemplate="body">
                <tr [ngStyle]= "{ 'backgroundColor' : (rowData.inlineEdited) ? '#a9d18e' : '' }" style="height: 40px;" >    
                    <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px; padding: 5px 5px 5px 12px;">
                        <div *ngIf="rowData.source != 'Internal'" >
                            <p-checkbox [(ngModel)]="rowData.checked" binary="true" id="{{rowData.uuid}}" name="{{rowData.uuid}}" [ngModelOptions]="{standalone: true}" (ngModelChange)="sensorCheckedChanged()" [disabled]="rowData.userFeatureAccess['EditSensor'] == false"></p-checkbox>
                        </div>
                    </td>

                    <td pEditableColumn [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px; padding: 5px 5px 5px 12px;" *ngIf="rowData.userFeatureAccess['EditSensor']" class="css-tooltip" [attr.tooltip-data]="rowData.id">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <div *ngIf="rowData.name=='' || rowData.name==undefined">
                                    {{ autoUpdateNameForUUID(rowData) }}
                                </div>
                                <input #pInputTextSensorName type="text" [(ngModel)]="rowData.name" id="rowData.id" name="rowData.id" (ngModelChange)="updateSensorDetails(rowData)" style="width: 180px" >
                            </ng-template>
                            <ng-template pTemplate="output">
                                <span> {{ rowData.name }}</span>
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    
                    <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px; padding: 5px 5px 5px 12px;" *ngIf="!rowData.userFeatureAccess['EditSensor']" class="css-tooltip" [attr.tooltip-data]="rowData.id">
                        {{ rowData.name }}
                    </td>

                    <td [ngStyle]="{'width': columns[2].width}" style="cursor: pointer; flex: none; border-width: 0px; padding: 5px 5px 5px 12px;"> 
                        <div (click)="showSensorLabelModal(rowData.uuid)" class="kig-link css-tooltip" [attr.tooltip-data]="rowData.associatedsensorGroupNames">
                            {{ rowData.uuid }}
                        </div> 
                    </td>

                    <td pEditableColumn [ngStyle]="{'width': columns[3].width}" style="flex: none; border-width: 0px; padding: 5px 5px 5px 12px;" *ngIf="rowData.userFeatureAccess['EditSensor']">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <div *ngIf="rowData.type == '' || rowData.type == undefined">
                                    {{autoUpdateTypeForUUID(rowData)}}
                                </div>
                                <input #pInputTextSensorType type="text" [(ngModel)]="rowData.type" id="rowData.uuid" name="rowData.uuid" (ngModelChange)="updateSensorDetails(rowData)" style="width: 180px" >
                            </ng-template>
                            <ng-template pTemplate="output">
                                <span> {{ rowData.type }}</span>
                            </ng-template>
                        </p-cellEditor>
                    </td>
                    <td [ngStyle]="{'width': columns[3].width}" style="flex: none; border-width: 0px; padding: 5px 5px 5px 12px;" *ngIf="!rowData.userFeatureAccess['EditSensor']">
                        {{ rowData.type }}
                    </td>

                    <td [ngStyle]="{'width': columns[4].width}" style="flex: none; border-width: 0px; padding: 5px 5px 5px 12px;">
                        {{ rowData.source }}
                    </td>

                    <td [ngStyle]="{'width': columns[5].width}" style="flex: none; border-width: 0px; padding: 5px 5px 5px 12px;">
                        <button *ngIf="sensorHasReadNowCapability(rowData)" (click)="captureSensorReadingNow(rowData, SensorDataResultsTemplate)" class="btn-basic css-tooltip" [attr.tooltip-data]="'Get current readings'" style="color: #5c8f3a; cursor: pointer; font-size: 14px; border: none; background-color: transparent; height: 28px; float: left;" ><i class="fa-solid fa-tower-broadcast"></i></button>
                        <button *ngIf="sensorHasBlinkNowCapability(rowData)" (click)="blinkSensorNow(rowData)" class="btn-basic css-tooltip" [attr.tooltip-data]="'Blink sensor'" style="color: #5c8f3a; cursor: pointer; font-size: 14px; border: none; background-color: transparent; height: 28px; float: right;" ><i class="fa-regular fa-lightbulb"></i></button>
                    </td>

                    <td [ngStyle]="{'width': columns[6].width}" style="flex: none; border-width: 0px; padding: 5px 5px 5px 12px;">
                        <!-- <div style="display: flex;">																																																							  -->
                            <!-- <div (click)="showSensorDataPreview(rowData)" class="fas fa-chart-line kig-link" style="cursor: pointer; font-size: 16px;" ></div>  -->
                            <label *ngIf="sensorHasActiveCalibrations(rowData) && !loadingCalibrationHistory">*</label>
                            <div *ngIf="loadingCalibrationHistory" style="font-size: 11px;">
                                <i class="fa fa-spinner fa-spin fa-1x fa-fw"></i>
                            </div>
                        <!-- </div> -->
                    </td>

                    <td [ngStyle]="{'width': columns[7].width}" style="flex: none; border-width: 0px; padding: 5px 5px 5px 12px;">
                        <div style="display: flex; gap: 12px;">
                            <div (click)="showSensorDataPreview(rowData)" class="fas fa-chart-line kig-link" style="cursor: pointer; font-size: 16px;" ></div>
                            <div *ngIf="rowData.lastReading.waitingForLoad">
                                <i class="fa fa-spinner fa-spin fa-1x fa-fw"></i>
                            </div>
                            <div *ngIf="!rowData.lastReading.waitingForLoad && rowData.lastReading.isLoaded" [ngStyle]="{'color': rowData.lastReading.displayColor }">
                                <i class="fa-solid fa-square"></i>
                                {{ rowData.lastReading.date | date: 'medium' }}
                            </div>
                        </div>
                    </td>
                    
                    <td [ngStyle]="{'width': columns[8].width}" style="flex: none; border-width: 0px; padding: 5px 5px 5px 12px;">
                        <div *ngIf="displaySensorSearchResults">
                            {{ rowData.searchResultsSummary }}
                        </div>
                    </td>

                    <td [ngStyle]="{'width': columns[9].width}" style="flex: none; border-width: 0px; padding: 5px 5px 5px 12px;">
                        <div *ngIf="displaySensorSearchResults">
                            {{ rowData.associatedsensorGroupNames }}
                        </div>
                    </td>

                    <td [ngStyle]="{'width': columns[10].width}" style="flex: none; border-width: 0px; padding: 5px 5px 5px 12px;">
                        <div *ngIf="!displaySensorSearchResults">
                            {{ rowData.displayedOwner }}
                        </div>
                    </td>

                    <td [ngStyle]="{'width': columns[11].width}" style="flex: none; border-width: 0px; padding: 5px 5px 5px 12px;">
                        {{ rowData.modifiedDate | date: 'medium' }}
                    </td>

                    <td [ngStyle]="{'width': columns[12].width}" style="flex: none; border-width: 0px; padding: 5px 5px 5px 12px;">
                        <div *ngIf="rowData.userFeatureAccess['EditSensor'] && rowData.source != 'Internal'"
                            (click)="editSensor(rowData,sensorEditTemplate)" aria-hidden="true"
                            class="fas fa-pencil-alt text-center" style="color:#64a70b; cursor: pointer; font-size: 14px;">
                        </div>
                        <div *ngIf="rowData.userFeatureAccess['ViewSensor'] && !rowData.userFeatureAccess['EditSensor']"
                            (click)="editSensor(rowData,sensorEditTemplate)" aria-hidden="true"
                            class="far fa-eye text-center" style="color:#1c4966; cursor: pointer; font-size: 14px;">
                        </div>
                    </td>

                    <td [ngStyle]="{'width': columns[13].width}" style="flex: none; border-width: 0px; padding: 5px 5px 5px 12px;">
                        <div *ngIf="rowData.userFeatureAccess['DeleteSensor']" (click)="onDeleteSensorConfirm(rowData)" aria-hidden="true"
                                class="far fa-trash-alt text-center" style="color:#c8102e; cursor: pointer; font-size: 14px;">
                        </div>
                    </td>

                </tr>
            </ng-template>
        </p-table>
    </div>
    <br>
 
    <label style="font-size: 14px; margin-left: 10px; margin-right: 10px;">Last Reading Color Key:</label>
    <label style="font-size: 14px; margin-right: 10px; color: #64a70b"><i class="fa-solid fa-square"></i> Day,</label>
    <label style="font-size: 14px; margin-right: 10px; color: #dadb26"><i class="fa-solid fa-square"></i> Week,</label>
    <label style="font-size: 14px; margin-right: 10px; color: #ff9551"><i class="fa-solid fa-square"></i> Month,</label>
    <label style="font-size: 14px; margin-right: 10px; color: purple"><i class="fa-solid fa-square"></i> 6 Months,</label>
    <label style="font-size: 14px; margin-right: 10px; color: #f93232"><i class="fa-solid fa-square"></i> 6+ Months</label>

    <br>
    <label style="font-size: 14px; margin-left: 10px; color: black">Readings*: Sensor using calibration equation(s)</label>

    <ng-template #noResults>
        <p *ngIf="searchedSensorUUID">No Results Found</p>
    </ng-template>

</div>


<ng-template #loading>
    <div class="col-xs-4 col-lg-3">
    <i class="fa fa-spinner fa-spin fa-2x fa-fw" style="margin: 30px 10px 0px 30px"></i>
    <span>Loading...</span>
    </div>
</ng-template>


<ng-template #sensorEditTemplate>
    <p-confirmDialog key="confirmDelete1" #confirmDelete1>
        <ng-template #footer>
            <button (click)="confirmDelete1.onAccept()" class="btn btn-success" type="button">Yes</button>
            <button (click)="confirmDelete1.onReject()" class="btn btn-basic" type="button">No</button>
        </ng-template>
    </p-confirmDialog>
    
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="edit-sensor-modal">
        <div style="background-color: #548235;  height: 7px;"></div>
        <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)"
            style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
            <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">Sensor:&nbsp;&nbsp; {{ common.getSensorDisplayName(sensor) }}</h5>
            <button (click)="sensorModalRef.hide()" class="ms-auto fas fa-times" type="button"
                style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;">
            </button>
        </div>
    
        <div class="modal-body">
            <tabset>
                <tab heading="General" active="true" class="tabset" style="padding: 10px;">
                    <div style="margin-bottom: 20px; display: flex; gap: 20px;">
                        <div class="form-group" style="width: 33%;">
                            <label for="sensorName" style="font-weight: 500;">Name</label>
                            <input [(ngModel)]="sensor.name" class="form-control" id="sensorName" name="sensorName"
                                [style.color]="!duplicateName ? 'black' : 'red' "
                                (ngModelChange)="duplicateNameCheck(sensor)" required type="text" />
                        </div>
    
                        <div class="form-group" style="width: 33%;">
                            <label for="SensorType" style="font-weight: 500;">Sensor Type</label>
                            <input type="text" name="SensorType" list="SensorTypes" class="form-control"
                                [(ngModel)]="sensor.type" (ngModelChange)="sensorTypeChanged()"
                                style="height: 38px; border-color: lightgray; color: black;" />
                            <datalist id="SensorTypes">
                                <option [value]="sensorType" *ngFor="let sensorType of sensorTypes">{{ sensorType }}
                                </option>
                            </datalist>
                        </div>
    
                        <div class="form-group" style="width: 33%;">
                            <label for="uuid" style="font-weight: 500;">UUID</label>
                            <input [(ngModel)]="sensor.uuid" class="form-control" id="uuid" name="uuid"
                                [style.color]="!duplicateUUID ? 'black' : 'red' "
                                (ngModelChange)="duplicateUUIDCheck(sensor)" required type="text"
                                [disabled]="sensor.id > 0" />
                        </div>
                    </div>
    
                    <div style="margin-bottom: 20px; display: flex; gap: 20px;">
                        <div class="form-group" style="width: 45%;">
                            <label for="userGroupSelection" style="font-weight: 500;">Access Group</label>
                            <ngx-select-dropdown name="userGroupSelection" [(ngModel)]="selectedUserGroup"
                                [config]="generalConfig" [options]="associatedUserGroups"
                                style="height: 26px;"></ngx-select-dropdown>
                        </div>
                        <div class="form-group" style="width: 15%;">
                            <label for="sensorSource" style="font-weight: 500;">Source</label>
                            <ngx-select-dropdown name="sensorSource" [(ngModel)]="sensorSourceSelection"
                                [config]="sensorSourceConfig" [options]="sensorSourceOptions" style="height: 26px;"
                                [disabled]="sensor.id > 0"></ngx-select-dropdown>
                        </div>
    
                        <div class="form-group" style="width: 40%;">
                            <label for="referenceInfo" style="font-weight: 500;">Reference Info (aka ProductID for Particle
                                Devices)</label>
                            <input [(ngModel)]="sensor.referenceInfo" class="form-control" id="referenceInfo"
                                name="referenceInfo" required type="text"
                                style="height: 38px; border-color: lightgray; color: black;" />
                        </div>
                    </div>
    
                    <div style="margin-bottom: 20px; display: flex; gap: 20px;">
                        <div class="form-group" style="width: 100%;">
                            <label for="datatypes" style="font-weight: 500;">Associated Reading Types</label>
                            <input [(ngModel)]="sensor.sensorReadingTypeNames" class="form-control" id="datatypes"
                                name="datatypes" required type="text" disabled=true
                                style="height: 38px; border-color: lightgray; color: black;" />
                        </div>
                    </div>
    
                    <div style="margin-bottom: 20px; display: flex; gap: 20px;">
                        <div class="form-group" style="width: 100%;">
                            <label for="sensorNotes" style="font-weight: 500;">Sensor Notes</label>
                            <textarea [(ngModel)]="sensor.notes" style="width: 100%; height: 60px; border-color: lightgray;"
                                type="text" name="sensorNotes"></textarea>
                        </div>
                    </div>
    

                    <div style="display: flex; gap: 10px; width: 100%; margin-bottom: 10px;">
                        <div class="form-group" style="width: 50%">
                            <label for="gps" style="font-weight: 500;">Default GPS</label>
                            <ng-select [items]=displayedGps bindLabel="name" name="defaultgps" [virtualScroll]="true"
                                (change)="selectedGpsLocationChanged($event)" placeholder="Use existing or create new"
                                [(ngModel)]="selectedGps" style="width: 100%" name="gps">
                            </ng-select>
                        </div>

                        <div class="form-group" style="width: 25%;">
                            <label for="gpsLat" style="font-weight: 500;">GPS Lat</label>
                            <input [(ngModel)]="sensor.gpsLocation.gpsLat" class="form-control" id="gpsLat"
                                name="gpsLat" (ngModelChange)="checkForNewLocation(sensor)" required type="number" />
                        </div>

                        <div class="form-group" style="width: 25%;">
                            <label for="gpsLong" style="font-weight: 500;">GPS Long</label>
                            <input [(ngModel)]="sensor.gpsLocation.gpsLong" class="form-control" id="gpsLong"
                                name="gpsLong" (ngModelChange)="checkForNewLocation(sensor)" required type="number" />
                        </div>
                    </div>
                    <div style="display: flex; gap: 10px; width: 100%;">
                        <div class="form-group" style="width: 100%;">
                            <label for="gpsLoc" style="font-weight: 500;">GPS Location Description</label>
                            <input [(ngModel)]="sensor.gpsLocation.locationDescription" class="form-control" id="gpsLoc"
                                name="gpsLoc" required type="text" />
                        </div>
                    </div>
                </tab>
            
                <tab heading="Virtual Sensor Parameters" *ngIf="sensorSourceSelection == 'Virtual'" style="padding: 10px;" class="tabset" >
                    <virtual-sensor-modal [sensor]="sensor" [allSensors]="allSensors" [allGpsInfos]="allGpsInfos"
                        [sensorReadingTypes]="sensorReadingTypes">
                    </virtual-sensor-modal>
                </tab>
            
                <tab heading="Calibrate" class="tabset" style="padding: 10px;">
                    <sensor-calibration
                        [(sensor)]="sensor"
                        [allSensors]="allSensors"
                        [notifyCalibrationHistoryActiveChanged]="notifyCalibrationHistoryActiveChanged">
                    </sensor-calibration>
                </tab>

                <tab heading="Existing Calibrations" class="tabset" style="padding: 0px;">
                    <sensor-calibration-history
                        [(sensor)]="sensor"
                        (calibrationDeleted)="loadCalibrationHistory(sensor)"
                        (calibrationUpdated)="loadCalibrationHistory(sensor)"
                        (activeCalibrationChanged)="onActiveCalibrationChanged($event)"
                        [associatedUserGroups]="associatedUserGroups">
                    </sensor-calibration-history>
                </tab>
            </tabset>
    
            <div *ngIf="sensor.userFeatureAccess['EditSensor']" style="margin-top: 15px;">
                <button (click)="deleteSensorReadingDataConfirmation1(SelectDatesTemplate)" class="btn btn-danger"
                    style="margin-right: 10px;" type="button">Delete Readings</button>
                <button (click)="selectReadingsForGPS(SelectDatesGpsTemplate)" class="btn btn-primary"
                    style="margin-right: 10px;" type="button">Apply GPS to Selected Readings</button>
                <!-- <button *ngIf="sensorSourceSelection == 'Virtual'" (click)="openVirtualSensorModal()" class="btn btn-primary" style="margin-right: 10px;" type="button">Configure Virtual Sensor</button> -->
                <div class="far fa-comment pull-right"
                    style="color:#5279bc; cursor: pointer; font-size: 20px; margin-left: 20px; margin-top: 8px"
                    aria-hidden="true" (click)="addNotes2ChangeLog()"></div>
                <button *ngIf="sensor.id != 0" class="btn btn-success pull-right"
                    (click)="updateOrCreateSensor(sensor, true)">Update</button>
                <button *ngIf="sensor.id == 0" class="btn btn-success pull-right"
                    (click)="updateOrCreateSensor(sensor, true)">Create</button>
                <button (click)="sensorModalRef.hide()" class="btn btn-basic col-xs-5 pull-right" style="margin-right: 10px;"
                    type="button">Cancel</button>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #groupOwnerTemplate>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="groupOwner-modal">
        <div style="background-color: #548235;  height: 7px;"></div>
            <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
                <h5 style="color: rgb(10, 10, 10); text-transform: none;">Change Sensor(s) Ownership</h5>
                <button
                    (click)="setOwnerModalRef.hide()"
                    class="ms-auto fas fa-times" type="button"
                    style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
                </button>
            </div>
        <div class=" modal-body">
            <div class="form-group" style="width: 400px;">
                <label for="userGroupSelection">Access Group</label>
                <ngx-select-dropdown name="userGroupSelection" [(ngModel)]="selectedUserGroup" [config]="generalConfig" [options]="associatedUserGroups" style="height: 26px;"></ngx-select-dropdown>  
            </div>
            <br>
            <div>
                <button type="button" class="btn btn-success" (click)="updateOwnerForSelectedSensors()" style="float: right; margin-right: 1px; margin-bottom: 0px; margin-top: 3px">Update</button>
                <button (click)="setOwnerModalRef.hide()" class="btn btn-basic pull-right" style="margin-right: 15px; margin-top: 3px; margin-bottom: 20px;" type="button">Cancel</button>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #SelectDatesTemplate>
    <p-confirmDialog key="confirmDelete2" #confirmDelete2>
        <ng-template #footer>
            <button (click)="confirmDelete2.onAccept()" class="btn btn-success" type="button">Yes</button>
            <button (click)="confirmDelete2.onReject()" class="btn btn-basic" type="button">No</button>
        </ng-template>
    </p-confirmDialog>

    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="selectDates-modal">
        <div style="background-color: #548235;  height: 7px;"></div>
        <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">     
            <h5 style="color: rgb(10, 10, 10); text-transform: none;">{{dataRangeSelectorTitle}}</h5>
            <button
            (click)="dateRangeSelectorRef.hide()"
            class="ms-auto fas fa-times" type="button"
            style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
            </button>
        </div>
  
        <div class="modal-body">
            <div style="display: flex; gap: 25px; align-items: center;">
                <div class="form-group" style="margin-top: 10px; margin-bottom: 10px;">
                    <input (datesUpdated)="datesUpdated()" [(ngModel)]="selectedDateRange" [alwaysShowCalendars]="true" [isInvalidDate]="isInvalidDate"
                        [linkedCalendars]="true" [ranges]="ranges" [showClearButton]="true" [showCustomRangeLabel]="true" autocomplete="off"
                        ngxDaterangepickerMd placeholder="Select Date Range" type="text" style="width:220px; height: 35px; font-size: medium;" />
                </div>
                <div *ngIf="selectedDateRange.startDate != undefined && selectedDateRange.endDate != undefined">
                    <button (click)="getReadingStatsForDateRange()" class="btn btn-success">Get Reading Counts</button>
                </div>
                <div *ngIf="processingReadingCounts" style="margin-top: 5px; font-size: 12px;">
                    <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
                </div>
                <div *ngIf="!processingReadingCounts" style="margin-top: 5px; font-size: 16px;">
                    {{ resultsOfSensorReadingDeletion }}
                </div>
            </div>

            <div *ngIf="readingTypesByCount.length > 0" style="margin-top: 5px; font-size: 16px; margin: 10px 0 10px 0;">
                <p-table #readingTypesCountTable [columns]="readingTypesCountCols" [scrollable]="true" [value]="readingTypesByCount" scrollHeight="30vh" sortMode="multiple">
                    <ng-template let-columns pTemplate="header">
                        <tr style="height: 45px;">
                            <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field" style="background-color: var(--kig-section-header-bg); flex: none;">
                                <div *ngIf="col.field == 'checked'" (click)="toggleCheckedSensorReadingsForDeletion()" style="padding-left: 4px; font-size: 20px;">▣</div>
                                {{col.header}}
                                <!-- <p-sortIcon *ngIf="col.header!=''" [field]="col.field"></p-sortIcon> -->
                            </th>
                        </tr>
                    </ng-template>
        
                    <ng-template let-columns="columns" let-i="rowIndex" let-rowData pTemplate="body">
                        <tr [ngStyle]= "{ 'backgroundColor' : (rowData.inlineEdited) ? '#a9d18e' : 'white' }" style="height: 40px;" >
                            
                            <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                                <p-checkbox [(ngModel)]="rowData.checked" binary="true" id="{{rowData.id}}" name="{{rowData.id}}" [ngModelOptions]="{standalone: true}" ></p-checkbox>
                            </td>

                            <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;" >
                                {{ rowData.id }}
                            </td>
        
                            <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px;" >
                                {{ rowData.type }}
                            </td>

                            <td [ngStyle]="{'width': columns[3].width}" style="flex: none; border-width: 0px;" >
                                {{ rowData.count }}
                            </td>
                        </tr>
                    </ng-template>
                </p-table>

                <button (click)="deleteSensorReadingDataConfirmation2()" class="btn btn-danger" style="margin-right: 10px; margin-top: 30px;" type="button">Delete Readings</button>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #SelectDatesGpsTemplate>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="selectDates-modal">
    <!-- <div class="modal-content selectDates-modal"> -->
        <div style="background-color: #548235;  height: 7px;"></div>
        <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">     
            <h5 style="color: rgb(10, 10, 10); text-transform: none;">{{dataRangeSelectorTitle}}</h5>
            <button
            (click)="dateRangeSelectorRef.hide()"
            class="ms-auto fas fa-times" type="button"
            style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
            </button>
        </div>
  
        <div class="modal-body">
            <div style="display: flex; gap: 25px; align-items: center;">
                <div class="form-group" style="margin-top: 10px; margin-bottom: 10px;">
                    <input (datesUpdated)="datesUpdated()" [(ngModel)]="selectedDateRange" [alwaysShowCalendars]="true" [isInvalidDate]="isInvalidDate"
                        [linkedCalendars]="true" [ranges]="ranges" [showClearButton]="true" [showCustomRangeLabel]="true" autocomplete="off"
                        ngxDaterangepickerMd placeholder="Select Date Range" type="text" style="width:220px; height: 35px; font-size: medium;" />
                </div>
                <div *ngIf="selectedDateRange.startDate != undefined && selectedDateRange.endDate != undefined">
                    <button (click)="updateSensorReadingsWithNewGpsInfo()" class="btn btn-success">Continue</button>
                </div>
                <div *ngIf="processingSensorReadingsForGps" style="margin-top: 5px; font-size: 12px;">
                    <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
                </div>
                <div *ngIf="!processingSensorReadingsForGPS" style="margin-top: 5px; font-size: 16px;">
                    {{ processingSensorReadingsForGpsResults }}
                </div>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #sensorReplaceTemplate>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="sensorReplace-modal">
    <!-- <div class="modal-content sensorReplace-modal"> -->
        <div style="background-color: #548235;  height: 7px;"></div>
        <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
            <h5 style="color: rgb(10, 10, 10); text-transform: none;">Replace Sensor</h5>
            <button
                (click)="sensorReplaceModalRef.hide()"
                class="ms-auto fas fa-times" type="button"
                style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
            </button>
        </div>

        <div class="modal-body">
            <div style="width: 570px; display: flex; gap: 10px; margin-top: 10px; margin-bottom: 20px; ">
                <label style="color: black; border-radius: 15px; text-align: center; display: inline-block; vertical-align: middle; width: 30px; height: 30px; margin-top: 36px;">1</label>
                <div class="form-group" style="width: 400px">
                    <label for="existingUUID" style="margin-top: 6px;">UUID of existing sensor to be replaced</label>
                    <input [(ngModel)]="existingSensorUUID" class="form-control" id="existingUUID" name="existingUUID" required type="text" />
                </div>
                <button (click)="openScan2Replace(scanToReplace, true)" class="btn btn-warning" type="button" style="width: 115px; height: 38px; margin-top: 30px;">Scan QR</button>
            </div>

            <div style="width: 570px; display: flex; gap: 10px; margin-top: 10px; margin-bottom: 30px;">
                <label style="color: black; border-radius: 15px; text-align: center; display: inline-block; vertical-align: middle; width: 30px; height: 30px; margin-top: 36px;">2</label>
                <div class="form-group" style="width: 400px">
                    <label for="newUUID" style="margin-top: 6px;">UUID of replacement sensor</label>
                    <input [(ngModel)]="replacementSensorUUID" class="form-control" id="newUUID" name="newUUID" required type="text" (change)="checkUUIDExistInSystem()"/>
                    <label *ngIf="replacementSensorUUIDExists" style="font-size: 14px;">*Note: Replacement sensor was previously registered</label>
                    <label *ngIf="existingSensorReadingsCount != ''" style="font-size: 14px; margin-left: 45px;">and has {{ existingSensorReadingsCount }} readings ingested within the last 5 years. Readings associated with the replacement sensor will be deleted before using this UUID/sensor to replace the sensor in step #1.</label>
                </div>
                <button (click)="openScan2Replace(scanToReplace, false)" class="btn btn-warning" type="button" style="width: 115px; height: 38px; margin-top: 30px;">Scan QR</button>
            </div>

            <div>
                <button *ngIf="existingSensorReadingsCheck == true" type="button" class="btn btn-info" (click)="replaceSensor()" [disabled]="existingSensorUUID == '' || replacementSensorUUID == ''" style="float: right; margin-right: 1px; margin-bottom: 0px; margin-top: 3px">Replace</button>
                <button *ngIf="existingSensorReadingsCheck == false" type="button" class="btn btn-info" (click)="checkUUIDExistInSystem()" [disabled]="existingSensorUUID == '' || replacementSensorUUID == ''" style="float: right; margin-right: 1px; margin-bottom: 0px; margin-top: 3px">Next</button>
                <button (click)="sensorReplaceModalRef.hide()" class="btn btn-basic col-xs-5 pull-right" style="margin-right: 15px; margin-top: 3px; margin-bottom: 15px;" type="button">Cancel</button>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #scanToReplace class="qrScanner" let-modal>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content">
        <div style="background-color: #548235;  height: 7px;"></div>
        <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
            <h5 class="modal-title pull-left" style="color: rgb(10, 10, 10); text-transform: none;">QR Code Scanner</h5>
            <button
                (click)="scanModalRef.hide()"
                class="ms-auto fas fa-times" type="button"
                style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
            </button>
        </div>
        <div class="modal-body qr-scanner-body" style="padding: 0px;">
            <kig-scanner (scanSuccess)="scanComplete($event)" (camerasFound)="camerasFound($event)" [device]="selectedDevice" id="scanZX"></kig-scanner><br>

            <select (change)="onDeviceSelectChange($event.target.value)" style="height: 38px; width: 455px; margin-left: 20px;">
                <option value="" [selected]="!selectedDevice">No Device</option>
                <option *ngFor="let device of availableDevices"
                    [value]="device.deviceId"
                    [selected]="selectedDevice && device.deviceId === selectedDevice.deviceId">{{ device.label }}
                </option>
            </select>

            <div style="display: flex; gap: 10px;">
                <input type="text" [(ngModel)]="scannedSensor" name="sensorUUID" style="width: 280px; height: 35px; margin-left: 20px; margin-top: 20px;" autofocus />
                <button (click)="selectSensor()" [disabled]="scannedSensor === ''" class="btn btn-success" id="acceptButton" type="button" style="height: 35px; margin-top: 20px; margin-right: 0px;">Select</button>
                <button (click)="ignoreSensor()" [disabled]="scannedSensor === ''" class="btn btn-danger" id="ignoreButton" type="button" style="height: 35px; margin-top: 20px;">Ignore</button>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #SensorDataResultsTemplate>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content">
    <!-- <div class="modal-content"> -->
        <div style="background-color: #548235;  height: 7px;"></div>
        <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">     
            <h6 style="color: rgb(10, 10, 10); text-transform: none;">Sensor Data for {{ sensorDataOnDemandName }}</h6>
            <button
            (click)="sensorDataResultsModelRef.hide()"
            class="ms-auto fas fa-times" type="button"
            style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
            </button>
        </div>
  
        <div class="modal-body">
            <div style="display: flex; gap: 5px;">
                <label style="width: 120px;">Sensor UID </label>
                <label>{{ sensorDataOnDemandName }}</label>
            </div>
            <div style="display: flex; gap: 5px;">
                <label style="width: 120px;">Created Date </label>
                <label>{{ sensorDataOnDemandResults.CreatedDate | date : 'medium' }}</label>
            </div>
            <div style="display: flex; gap: 5px; margin-bottom: 15px;">
                <label style="width: 120px;">Tag/Gateway </label>
                <label>{{ sensorDataOnDemandResults.Tag }}</label>
            </div>
            <div style="display: flex; gap: 5px;" *ngFor="let item of sensorDataOnDemandResults.PayLoad | keyvalue">
                <label style="width: 180px;">{{ item.key }} </label>
                <label>{{ item.value }}</label>
            </div>
            <br>
            <div *ngIf="sensorDataOnDemandMessage != ''">
                <label>{{ sensorDataOnDemandMessage }}</label>
            </div>
        </div>
    </div>
</ng-template>
